import {h, JSX} from 'preact'
import {Modal} from './Modal'
import {CashRegisterIcon, CheckIcon} from './Icons';
import classNames from 'classnames';
import {TextField, TextFieldProps} from './TextField';

export interface Bill {
    value: number,
    label: string;
    image: string,
}

export interface CashModalProps {
    title: string;
    confirmButtonLabel: string;
    cancelButtonLabel: string;
    openRegisterLabel: string;
    show: boolean;
    toggleModal: () => void;
    onConfirm: () => void;
    onOpenRegister: () => void;
    bills: Bill[];
    onBillClick: (value: number) => void;
    onKeyClick: (value: string) => void;
    paidAmountField: TextFieldProps;
    keys: string[];
    toPay: {
        label: string,
        value: string
    };
    toReturn: {
        label: string,
        value: string
    }
}

export const CashModal = (props: CashModalProps): JSX.Element => (
    <Modal
        show={props.show}
        toggleModal={props.toggleModal}
        title={props.title}
        hasCloseButton
        containerClass='max-w-[764px]'
    >
        <div class='flex flex-col'>
            <div class='flex py-6 px-8 grow gap-[49px]'>
                <div class='basis-1/2'>
                    <div class='flex flex-wrap -m-1'>
                        {props.bills.map((bill) => (
                            <div key={bill.value} class='basis-1/3 p-1'>
                                <button class='btn flex flex-col btn-gray p-2.5 w-full text-sm lg:text-base' onClick={() => props.onBillClick(bill.value)}>
                                    <div class="min-h-[50px] flex items-center">
                                        <img
                                            class='pointer-events-none max-h-[50px]'
                                            src={bill.image}
                                            alt={bill.label}
                                        />
                                    </div>
                                    {bill.label}
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
                <div class='basis-1/2'>
                    <div class='flex flex-wrap -m-1'>
                        {props.keys.map((key, index) => (
                            <div
                                key={index}
                                class={classNames(
                                    'p-1',
                                    props.keys.length % 3 !== 0 && index == props.keys.length - 2 ? 'basis-2/3' : 'basis-1/3',
                                )}
                            >
                                <button
                                    className='btn btn-gray p-2 text-center text-2xl leading-[40px] font-semibold w-full h-full'
                                    onClick={() => props.onKeyClick(key)}
                                >
                                    {key}
                                </button>
                            </div>
                        ))}
                    </div>
                    <table class='[&>tr+tr>td]:pt-6 mt-6'>
                        {props.toPay && (
                            <tr>
                                <td class='font-semibold pr-6 text-sm leading-6'>
                                    {props.toPay.label}
                                </td>
                                <td class='font-bold text-base'>
                                    {props.toPay.value}
                                </td>
                            </tr>
                        )}
                        {props.paidAmountField && (
                            <tr>
                                <td class='font-semibold pr-6 text-sm leading-6'>
                                    Kliendilt
                                </td>
                                <td class='font-bold text-base'>
                                    <TextField {...props.paidAmountField}/>
                                </td>
                            </tr>
                        )}
                        {props.toReturn && (
                            <tr>
                                <td class='font-semibold pr-6 text-sm leading-6'>
                                    {props.toReturn.label}
                                </td>
                                <td class='font-semibold text-base'>
                                    {props.toReturn.value}
                                </td>
                            </tr>
                        )}
                    </table>
                </div>
            </div>
            <div class='flex shrink justify-between items-center border-t px-8 py-6'>
                {props.onOpenRegister && (
                    <button onClick={props.onOpenRegister} className='btn btn-border px-4 py-3'>
                        <CashRegisterIcon/>
                        {props.openRegisterLabel}
                    </button>
                )}
                <div class='flex gap-2.5'>
                    {props.cancelButtonLabel && (
                        <button onClick={props.toggleModal} className='btn btn-border p-4 text-base leading-[14px]'>
                            {props.cancelButtonLabel}
                        </button>
                    )}
                    {props.confirmButtonLabel && props.onConfirm && (
                        <button onClick={props.onConfirm} className='btn btn-light-blue p-4 text-base leading-[14px]'>
                            <CheckIcon/>
                            {props.confirmButtonLabel}
                        </button>
                    )}
                </div>
            </div>
        </div>
    </Modal>
);
